import { render, staticRenderFns } from "./detecation-items-edit.vue?vue&type=template&id=c9b4bf8a&scoped=true"
import script from "./detecation-items-edit.vue?vue&type=script&lang=ts"
export * from "./detecation-items-edit.vue?vue&type=script&lang=ts"
import style0 from "./detecation-items-edit.vue?vue&type=style&index=0&id=c9b4bf8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9b4bf8a",
  null
  
)

export default component.exports